function miamiScaleDimensions(value, aspect=1, optionName='Size') {
  const text=String(value || '').toLowerCase().replace(/,/g,'');
  if(/-\s*\d/.test(text))return null;
  const pair=text.match(/(\d+(?:\.\d+)?)\s*(inches|inch|in\b|centimeters?|centimetres?|cm\b|millimeters?|millimetres?|mm\b|feet|foot|ft\b|")?\s*[x×*]\s*(\d+(?:\.\d+)?)\s*(inches|inch|in\b|centimeters?|centimetres?|cm\b|millimeters?|millimetres?|mm\b|feet|foot|ft\b|")?/);
  const single=text.match(/(\d+(?:\.\d+)?)\s*(inches|inch|in\b|centimeters?|centimetres?|cm\b|millimeters?|millimetres?|mm\b|feet|foot|ft\b|")/);
  if(!pair && !single)return null;
  const factor=unit=>/^mm|millimet/.test(unit)?1/25.4:/^cm|centimet/.test(unit)?1/2.54:/^ft|feet|foot/.test(unit)?12:1;
  const name=String(optionName).toLowerCase();
  let width=pair ? Number(pair[1])*factor(pair[2]||pair[4]||'in') : Number(single[1])*factor(single[2]);
  let height;
  if(pair)height=Number(pair[3])*factor(pair[4]||pair[2]||'in');
  else if(name.includes('height')) {height=width;width=height*aspect;}
  else if(name.includes('width') || aspect>=1) height=width/aspect;
  else {height=width;width=height*aspect;}
  if(!Number.isFinite(width+height) || width<=0 || height<=0 || width>1200 || height>1200) return null;
  return {width,height,label:String(value)};
}

if(typeof customElements!=='undefined' && !customElements.get('miami-product-scale-gallery')) {
  class MiamiProductScaleGallery extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;
      this.config=JSON.parse(this.querySelector('[data-scale-config]').textContent);
      this.root=this.closest('[data-section-type="product-page"]');
      this.host=this.closest('.m-main-product--media');
      this.sign=this.querySelector('[data-scale-sign]');
      this.stage=this.querySelector('[data-scale-stage]');
      this.sizeLabel=this.querySelector('[data-scale-size]');
      this.sizeSelect=this.querySelector('[data-scale-size-select]');
      this.panels=Array.from(this.querySelectorAll('[data-scale-panel]'));
      this.buttons=Array.from(this.querySelectorAll('[data-scale-target]'));
      this.position=Number(this.dataset.sizePosition)-1;
      this.current=this.config.variants.find(v=>String(v.id)===this.dataset.selectedVariant) || this.config.variants[0];
      const svg=this.sign.querySelector('svg');
      if(!svg || svg.viewBox.baseVal.width<=0 || svg.viewBox.baseVal.height<=0)return;
      this.aspect=svg.viewBox.baseVal.width/svg.viewBox.baseVal.height;
      this.activePanel='room';
      this.onVariant=event=>{
        if(event.target.matches('[name="id"]')) this.setVariant(event.target.value);
      };
      this.onChange=()=>requestAnimationFrame(()=>{
        const input=this.root?.querySelector('form[action*="/cart/add"] [name="id"]');
        if(input)this.setVariant(input.value);
      });
      this.onClick=event=>{
        const thumbnail=event.target.closest('[data-scale-target]');
        if(thumbnail && this.contains(thumbnail))this.showPanel(thumbnail.dataset.scaleTarget);
        const direction=event.target.closest('[data-scale-direction]');
        if(direction && this.contains(direction))this.nextPanel(Number(direction.dataset.scaleDirection));
      };
      this.onKey=event=>{
        if(event.key==='ArrowLeft'){event.preventDefault();this.nextPanel(-1);}
        if(event.key==='ArrowRight'){event.preventDefault();this.nextPanel(1);}
      };
      this.onRoomSize=event=>{
        if(event.target===this.sizeSelect)this.chooseSize(event.target.value);
      };
      this.onTouchStart=event=>{this.touchX=event.changedTouches[0].clientX;this.touchY=event.changedTouches[0].clientY;};
      this.onTouchEnd=event=>{
        const dx=event.changedTouches[0].clientX-this.touchX;
        const dy=event.changedTouches[0].clientY-this.touchY;
        if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.3)this.nextPanel(dx<0?1:-1);
      };
      this.root?.addEventListener('input',this.onVariant,true);
      this.root?.addEventListener('change',this.onChange,true);
      this.addEventListener('click',this.onClick);
      this.addEventListener('change',this.onRoomSize);
      this.stage.addEventListener('keydown',this.onKey);
      this.stage.addEventListener('touchstart',this.onTouchStart,{passive:true});
      this.stage.addEventListener('touchend',this.onTouchEnd,{passive:true});
      this.enable();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('input',this.onVariant,true);
      this.root?.removeEventListener('change',this.onChange,true);
      this.removeEventListener('click',this.onClick);
      this.removeEventListener('change',this.onRoomSize);
      this.stage?.removeEventListener('keydown',this.onKey);
      this.stage?.removeEventListener('touchstart',this.onTouchStart);
      this.stage?.removeEventListener('touchend',this.onTouchEnd);
      this.host?.removeAttribute('data-scale-gallery-ready');
      this.ready=false;
    }

    measure(variant) {
      return miamiScaleDimensions(variant?.options?.[this.position],this.aspect,this.config.options[this.position]);
    }

    enable() {
      const sizes=this.config.variants.map(v=>this.measure(v)).filter(Boolean);
      if(!sizes.length || !this.measure(this.current))return;
      this.sceneInches=Math.max(96,...sizes.map(s=>s.width/.72),...sizes.map(s=>s.height/.53));
      const roomScale=96/this.sceneInches;
      this.style.setProperty('--mn-scene-scale',roomScale);
      this.style.setProperty('--mn-sign-center',((1-.38*roomScale)*54)+'%');
      this.dataset.enabled='true';
      this.host?.setAttribute('data-scale-gallery-ready','');
      this.updateSize();
    }

    setVariant(id) {
      const variant=this.config.variants.find(v=>String(v.id)===String(id));
      if(!variant || !this.measure(variant))return;
      const previous=this.current;
      this.current=variant;
      this.dataset.activeVariant=String(variant.id);
      if(this.dataset.enabled==='true')this.updateSize();
      const changed=previous?.options?.[this.position]!==variant.options[this.position];
      if(changed)this.showPanel('room');
    }

    updateSize() {
      const size=this.measure(this.current);
      if(!size || !this.sceneInches)return;
      this.style.setProperty('--mn-sign-width',(100*size.width/this.sceneInches)+'%');
      this.style.setProperty('--mn-sign-height',(100*size.height/this.sceneInches)+'%');
      this.sizeLabel.textContent=size.label;
      this.sizeSelect.value=size.label;
      this.dataset.activeVariant=String(this.current.id);
      this.dataset.previewWidth=String(size.width);
      this.dataset.previewHeight=String(size.height);
    }

    chooseSize(value) {
      const picker=this.root?.querySelector('variant-picker');
      if(!picker)return;
      const input=Array.from(picker.querySelectorAll('input[type="radio"]')).find(el=>el.value===value);
      if(input){
        const label=Array.from(picker.querySelectorAll('label')).find(el=>el.htmlFor===input.id);
        if(label)label.click();
        return;
      }
      const select=Array.from(picker.querySelectorAll('select')).find(el=>Array.from(el.options).some(option=>option.value===value));
      if(select){select.value=value;select.dispatchEvent(new Event('change',{bubbles:true}));}
    }

    showPanel(target) {
      if(!this.panels.some(p=>p.dataset.scalePanel===String(target)))return;
      this.activePanel=String(target);
      for(const panel of this.panels){
        panel.hidden=panel.dataset.scalePanel!==this.activePanel;
        if(panel.hidden)for(const video of panel.querySelectorAll('video'))video.pause();
      }
      for(const button of this.buttons)button.setAttribute('aria-pressed',String(button.dataset.scaleTarget===this.activePanel));
    }

    nextPanel(step) {
      const index=this.panels.findIndex(p=>p.dataset.scalePanel===this.activePanel);
      this.showPanel(this.panels[(index+step+this.panels.length)%this.panels.length].dataset.scalePanel);
    }

  }
  customElements.define('miami-product-scale-gallery',MiamiProductScaleGallery);
}
if(typeof module!=='undefined' && module.exports)module.exports={miamiScaleDimensions};

